<div class="dialog">
  <h2 class="title">Add New Company</h2>
  <p class="subtitle">Create a new company account. Fill in the details below.</p>

  <form [formGroup]="companyForm" (ngSubmit)="submit()" class="form">

    <label class="field">
      <span>Company Name</span>
      <input type="text" formControlName="name" placeholder="e.g. TechSolution" />
    </label>

    <label class="field">
      <span>Industry</span>
      <input type="text" formControlName="industry" placeholder="e.g. Technology" />
    </label>

    <label class="field">
      <span>Location</span>
      <input type="text" formControlName="location" placeholder="e.g. Munich, Germany" />
    </label>

    <div class="upload">
      <div class="uploader">
        <label class="drop" [class.hasPreview]="!!imagePreviewUrl">
          <input type="file" accept="image/*" (change)="onFileSelected($event)" hidden />
          <ng-container *ngIf="!imagePreviewUrl; else preview">
            <div class="plus">+</div>
          </ng-container>
          <ng-template #preview>
            <img [src]="imagePreviewUrl!" alt="logo preview" />
          </ng-template>
        </label>
      </div>
      <div class="upload-label">Add Company Logo</div>
      <div class="error" *ngIf="imageError">{{ imageError }}</div>
    </div>

    <label class="field">
      <span>Website</span>
      <input type="text" formControlName="website" placeholder="www.company.com" />
    </label>

    <label class="field">
      <span>Description</span>
      <textarea formControlName="description" rows="3" placeholder="Short description of the company"></textarea>
    </label>

    <label class="field">
      <span>Partner email</span>
      <input type="email" formControlName="partnerEmail" placeholder="partner@company.com" />
    </label>

    <label class="field">
      <span>Role</span>
      <select formControlName="role">
        <option value="" disabled selected>Select role</option>
        <option value="AGENCY">AGENCY</option>
        <option value="PARTNER">PARTNER</option>
      </select>
    </label>

    <label class="field" *ngIf="companyForm.get('role')?.value === 'AGENCY'">
      <span>Institution Code</span>
      <input type="text" formControlName="institutionCode" placeholder="Enter institution code" />
    </label>

    <div class="actions">
      <button type="button" class="btn ghost" (click)="close()">Cancel</button>
      <button type="submit" class="btn primary" [disabled]="companyForm.invalid || isSubmitting">
        <span>Save & Continue</span>
        <span class="arrow">➜</span>
      </button>
    </div>
  </form>
</div>
